import React from "react";


import ActionButtons from "components/flowable/SummaryBudget/SummaryBudgetFooter/ActionButtons";
import UploadFooter from "components/flowable/SummaryBudget/SummaryBudgetFooter/UploadFooter";
import useDictionary from "hooks/useDictionary";

export const SummaryBudgetFooter = ({
	config,
	edit,
	handleCancel,
	handleSave,
	inputType,
	onChange,
	UploadComponent,
	...rest
}) => {
	const dictionary = useDictionary("summaryBudget");
	const defaultInputTypes = dictionary.inputTypes;

	const displayFooter = () => {
		switch(inputType) {
		case defaultInputTypes.upload:
			return (
				<UploadFooter
					config={config}
					UploadComponent={UploadComponent}
					onChange={onChange}
					{...rest}
				/>
			);
		case defaultInputTypes.manual:
			return (
				<ActionButtons
					disabled={!config.enabled}
					edit={edit}
					handleCancel={handleCancel}
					handleSave={handleSave}
				/>
			);
		default:
			return <></>;
		}
	};

	return displayFooter();
};

export default SummaryBudgetFooter;
